import { FC, lazy, Suspense } from 'react';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

const LazyComponent = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedRingSizeGuideModalWrapper" */ './PdpSharedRingSizeGuideModalWrapper'
        )
);

export const PdpSharedRingSizeGuideModalLazy: FC<Props> = props =>
    props.isOpen ? (
        <Suspense fallback={null}>
            <LazyComponent {...props} />
        </Suspense>
    ) : null;
